<template>
  <user-item :user="subscriber.user">
    <template #desktop-actions>
      <div class="anz-flex anz-justify-content-center">
        <a-button
          className="anz-btn anz-btn-border anz-btn-s anz-btn-border-hover-primary anz-mr-xs anz-text-nowrap"
          @click="remove"
          :loading="removing"
          :disabled="isProfileWriteDisabled"
          :class="{
            'anz-link-disabled': isProfileWriteDisabled,
          }"
          show-icon
          icon-width="0.9285em"
          icon-height="1em"
          icon-class="anz-mr-xs anz-color-primary"
          loader-class="anz-mr-xs anz-spinner-xs"
        >
          <template #title>
            {{ $translate('profile.actions.unsubscribe') }}
          </template>
        </a-button>
        <a-button
          :title="$translate('profile.actions.profileDetail')"
          className="anz-btn anz-btn-border anz-btn-s anz-btn-border-hover-primary anz-text-nowrap"
          add-href
          :href="generateProfileRoute(subscriber.user)"
        />
      </div>
    </template>
    <template #mobile-actions>
      <div class="anz-flex">
        <a-button
          className="anz-btn anz-btn-border anz-mb-l anz-mr-m anz-flex-fill"
          @click="remove"
          :loading="removing"
          :disabled="isProfileWriteDisabled"
          :class="{
            'anz-link-disabled': isProfileWriteDisabled,
          }"
          show-icon
          icon-width="0.9285em"
          icon-height="1em"
          icon-class="anz-mr-xs anz-color-primary"
          loader-class="anz-mr-xs anz-spinner-xs"
        >
          <template #title>
            {{ $translate('profile.actions.unsubscribe') }}
          </template>
        </a-button>
        <a-button
          :title="$translate('profile.actions.profileDetail')"
          className="anz-btn anz-btn-primary anz-mb-l anz-flex-fill"
          add-href
          :href="generateProfileRoute(subscriber.user)"
        />
      </div>
    </template>
  </user-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import { useRouter } from '@/routing/router'
import UserItem from '@/components/Profile/Lists/Single/UserItem.vue'
import useSubscriberManager from '@/composables/subscribers/subscribersManager'
import { useSubscriberActions } from '@/composables/ui/uiActions'

export default defineComponent({
  name: 'SubscriberUserItem',
  emits: ['removed'],
  components: {
    UserItem,
    AButton,
  },
  props: {
    subscriber: {
      type: Object,
      default: {},
    },
  },
  setup(props, context) {
    const { removing, removeSubscription } = useSubscriberManager()

    const remove = async () => {
      await removeSubscription(props.subscriber.id)
      context.emit('removed', props.subscriber.id)
    }

    return {
      removing,
      remove,
      ...useRouter(),
      ...useSubscriberActions(),
    }
  },
})
</script>
